module.exports = __webpack_public_path__ + "static/media/TB1txw7bNrI8KJjy0FpXXb5hVXa-260-260.8c382430.png";